export default {
    message: {
        tiers: {
            t1: {
                label: "독립 실행형",
                desc: "<p>모든 가상, 웹 및 SaaS 앱에 대한 통합 액세스로, 엔드투엔드 상황별 보안 제어를 통해 사용자, 앱 및 데이터를 보호합니다.</p><p>VPN이 없는 프록시 및 SSO로 웹, SaaS, 가상 및 모바일 앱 연결과 악성 콘텐츠, 키로거 및 화면 캡처 맬웨어 방지 기능을 제공합니다.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>세부적인 보안성이 갖추어진 전체 디지털 업무 공간이 필요하지만, 가상 앱 및 데스크탑은 필요하지 않은 직원들을 위한 완벽한 업무 공간 솔루션입니다.</p><p>Workspace Standard 기능은 물론 SaaS 및 웹을 위한 고급 보안 제어, 통합 엔드포인트 관리, 그리고 Content Collaboration Premium까지도 포함되어 있습니다.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Citrix Virtual Apps and Desktops를 위한 하이브리드 구축 옵션이 포함된 포괄적 업무 공간 솔루션입니다.</p><p>Workspace Premium 기능은 물론 Citrix Virtual Apps and Desktops용 클라우드 관리 옵션까지 포함되어 있습니다.</p>"
            }
        }
    }
}